import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, MapPin } from "lucide-react"; // Added MapPin
import { PopupModal } from "react-calendly";

// Reworked Hero Component
function Hero() {
	const [openBooking, setOpenBooking] = useState(false);

	return (
		<section className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden ">
			{/* Enhanced Background Image - More visible and aspirational */}
			<div className="absolute inset-0 ">
				<div className="absolute top-0 left-1/2 transform -translate-x-1/2 mt-8 text-center text-white  text-md md:text-lg font-semibold">
					Valid Until Jan 5, 2026
				</div>
				<picture>
					{/* 모바일 전용 */}
					<source
						srcSet="/images/boxing_day_mobile.webp"
						type="image/webp"
						media="(max-width: 640px)"
					/>
					{/* 큰 화면 전용 */}
					<source
						srcSet="/images/boxing_day.webp"
						type="image/webp"
						media="(min-width: 641px)"
					/>
					<img
						src="/images/boxing_day.webp" // fallback
						alt="Hero room"
						fetchpriority="high"
						className="w-full h-full object-cover object-center"
						width={1920}
						height={1080}
					/>
				</picture>
			</div>
			{/* Overlay for text readability */}
			{/* <div className="absolute inset-0 bg-white/30 sm:bg-white/10 md:bg-transparent bg-gradient-to-r from-white/70 via-white/20 to-transparent"></div> */}
			<div className="flex flex-col justify-self-center items-center mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
				<div className="max-w-2xl text-center sm:text-left ">
					{/* Headline - Clearer Benefit & Scope */}
					<motion.h1
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, ease: "easeOut" }}
						className="text-5xl md:text-9xl text-white tracking-tight font-prata text-center "
					>
						Boxing Week <br />
						<span className="block text-white text-3xl md:text-7xl font-sans tracking-[0.5rem] lg:tracking-[1.6rem]  font-semibold mb-10">
							Clearance
						</span>
						<span className="text-secondary text-10xl">40% Off</span>{" "}
						<span className="block text-black  text-3xl lg:text-4xl font-sans tracking-widest font-bold">
							clearance styles
						</span>
						{/* Prominent Savings */}
					</motion.h1>
					{/* Subheadline - Reinforce Key Selling Points (Customer Obsession: Address quality, origin, ease) */}
					{/* <motion.p
						initial={{ opacity: 0, x: -30 }}
						animate={{ opacity: 1, x: 0 }}
						transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
						className="mt-4 text-lg md:text-xl text-gray-700"
					>
						Transform your space with premium, handcrafted shades made right
						here in Toronto. Get the perfect fit, style, and price, delivered
						fast.
					</motion.p> */}
					{/* CTAs - Clear Primary and Secondary Actions */}
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
						className="mt-14 flex flex-col sm:flex-row sm:items-center gap-4 items-center justify-center"
					>
						<Link
							to="/shop" // Direct link to product browsing/customization
							className="border-2 border-secondary inline-block w-full sm:w-auto bg-secondary text-white px-8 py-5 rounded-lg font-semibold text-lg text-center shadow-md hover:bg-secondary/80 transition-all duration-300"
						>
							Shop Now & Save
						</Link>

						{/* Optional: Consultation Button - Kept less prominent than Shop/Samples initially */}
						{/* <button
                            onClick={() => setOpenBooking(true)}
                            className="inline-block w-full sm:w-auto text-gray-600 hover:text-primary font-medium text-center transition-all duration-300"
                        >
                            Book Free Consultation
                        </button> */}
					</motion.div>
					{/* Trust Badges - More Specific and Trust-Building */}
				</div>
			</div>
			{/* Calendly Popup Modal */}
			<PopupModal
				url="https://calendly.com/offcutshades"
				rootElement={document.getElementById("root")}
				open={openBooking}
				onModalClose={() => setOpenBooking(false)}
				// Use default Calendly styling or pass specific props if needed
			/>
		</section>
	);
}

export default Hero;
